module.exports = __webpack_public_path__ + "img/vector.72447cbc.svg";